import React from "react";
import MaterialTable from "material-table";
import { translator } from "../../utils/i18n";
import { useDispatch, useSelector } from "react-redux";
import { deleteUserAnnex } from "../../utils/fetcher";
import Avatar from "@material-ui/core/Avatar";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import DateRangeIcon from "@material-ui/icons/DateRange";
import ConfirmDialog from "./ConfirmDialog";
import EditAccountAttached from "./EditAccountAttached";
import AddNewPerson from "./AddNewPerson";
import AlertDialog from "../../components/AlertDialog";
import { setMessageWithCode } from "../../actions";

function MyAccounts() {
  const listAcounts = useSelector(state =>
    state.patientArea.linkedAccounts ? state.patientArea.linkedAccounts : []
  );
  const dispatch = useDispatch();
  const deleteUserAnnexFunc = userId => dispatch(deleteUserAnnex(userId));

  const state = {
    columns: [
      { title: `contenu`, field: "content", filtering: false },
      { title: `Nom`, field: "lastName", filtering: false },
      { title: `Prénom`, field: "firstName" },
      { title: `Lien de parenté`, field: "relationship" },
      { title: `Date de naissance`, field: "dob", filtering: false }
    ]
  };
  const message = useSelector(state => state.messageWithCode);

  const buildHtml = () => {
    let newData = [];
    if (listAcounts) {
      newData = listAcounts.map(item => {
        const html = (
          <div className="wrap-item" key={item.userId}>
            <Avatar className="avatar-orange margin-auto avatar-big">
              {item.lastName.charAt(0)}
              {item.firstName.charAt(0)}
            </Avatar>
            <div className="infos">
              <strong className="name">
                {item.civility} {item.lastName} {item.firstName}
              </strong>
              <ul className="un-styled infos-user">
                <li>
                  <PermIdentityIcon />
                  {item.firstName} {item.lastName}
                </li>
                <li>
                  <DateRangeIcon />
                  {item.dob}
                </li>
              </ul>
            </div>
            <div className="settings p-0 flex-direction-column settings-actions">
              <div className="item-btn">
                <ConfirmDialog
                  label={translator()._(
                    "W_SOUHAITEZ_VOUS_VRAIMENT_SUPPRIMER_L_UTILISATEUR"
                  )}
                  handleClick={() => deleteUserAnnexFunc(item.userId)}
                />
              </div>
              <div className="item-btn">
                <EditAccountAttached user={item} />
              </div>
            </div>
          </div>
        );
        return {
          content: html,
          userId: item.userId,
          lastName: item.lastName,
          firstName: item.firstName,
          nameDoctor: item.nameDoctor,
          motif: item.motif,
          date: item.date,
          Hour: item.Hour
        };
      });
    }
    return newData;
  };

  return (
    <>
      {message && message.code === -1 && (
        <AlertDialog
          isHideTitle={true}
          content={message.text}
          onClick={() => {
            dispatch(setMessageWithCode({}));
          }}
          isResetAlert={true}
        />
      )}
      {listAcounts && (
        <div className="wrap-custom-table">
          <h1 className="title-page">
            {translator()._("CP_MENU_COMPTES_LIES")}
          </h1>
          <div className="wrap-inner-table filter-disabled">
            <MaterialTable
              title=""
              columns={state.columns}
              data={buildHtml()}
              showFirstLastPageButtons={false}
              options={{
                actionsColumnIndex: -1,
                maxBodyHeight: 350,
                pageSize: 2
              }}
              localization={{
                pagination: {
                  labelDisplayedRows: "{from}-{to} of {count}",
                  previousTooltip: `${translator()._("W_PREVIOUS_PAGE")}`,
                  nextTooltip: `${translator()._("W_NEXT_PAGE")}`,
                  lastTooltip: `${translator()._("W_LAST_PAGE")}`,
                  firstTooltip: `${translator()._("W_FIRST_PAGE")}`
                },
                toolbar: {
                  nRowsSelected: "{0} row(s) selected",
                  searchPlaceholder: `${translator()._("CP_SEARCH")}`
                },
                header: {
                  actions: "Actions"
                },
                body: {
                  deleteTooltip: `${translator()._("W_SUPPRIMER")}`,
                  emptyDataSourceMessage: `${translator()._(
                    "CP_WELCOME_NO_ACCOUNT"
                  )}`,
                  filterRow: {
                    filterTooltip: "Filter"
                  },
                  editRow: {
                    deleteText: `${translator()._(
                      "W_SOUHAITEZ_VOUS_VRAIMENT_SUPPRIMER_RENDEZ_VOUS"
                    )}`,
                    cancelTooltip: `${translator()._("W_ANNULER")}`,
                    saveTooltip: `${translator()._("W_STEP_BOUTON_CONTINUER")}`
                  }
                }
              }}
            />
          </div>
          <AddNewPerson />
        </div>
      )}
    </>
  );
}

export default MyAccounts;
